import React, { useContext } from 'react';
import { UserInfoContext } from '../user/user-info';
import { OnboardingInfoContext } from '../onboarding/onboarding-info';
import { OnboardingTicketView } from '../onboarding/OnboardingTicketView';
import { OnboardingContextHOC } from '../onboarding/OnboardingContextHOC';
import { BackToSetup } from '../onboarding/BackToSetup';

export const EmptyTicket = OnboardingContextHOC(() => {
  const { isRenderOnboardingTicketView } = useContext(OnboardingInfoContext);
  const { inboxEnabled } = useContext(UserInfoContext);

  if (isRenderOnboardingTicketView) return <OnboardingTicketView />;
  if (inboxEnabled) return null;
  return (
    <div
      id="ticket"
      className="ui-column-3 not-mobile flex"
    >
      <BackToSetup />
      <div id="ticketless" />
    </div>
  );
});
